import { List } from "@refinedev/antd";
import { Tabs } from "antd";
import React from "react";
import { FlatFeeAnalyticsPage } from "./analytics";
import { FlatFeeImoReportPage } from "./imo-report";
import { FlatFeeAlertSettingsPage } from "./alert-settings";

// Single nav entry for the three flat-fee pages, one per tab. destroyOnHidden
// is left false (antd's default) so switching tabs does not unmount the
// inactive pages - each tab's local state (filters, drafts, generated
// report) survives the switch.
export const FlatFeeHubPage: React.FC = () => {
  return (
    <List title="Flat Fee Analytics">
      <Tabs
        destroyOnHidden={false}
        items={[
          {
            key: "analytics",
            label: "Analytics",
            children: <FlatFeeAnalyticsPage />,
          },
          {
            key: "imo-report",
            label: "IMO Report",
            children: <FlatFeeImoReportPage />,
          },
          {
            key: "alert-settings",
            label: "Alert Settings",
            children: <FlatFeeAlertSettingsPage />,
          },
        ]}
      />
    </List>
  );
};
